import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d182f2e")

_pushScopeId("data-v-4d182f2e")
const _hoisted_1 = { class: "stepper-comp flex flex-col justify-between" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_component = _resolveComponent("icon-component")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["relative cursor-pointer no-select", _ctx.disabledUp ? '' : _ctx.classAtt],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPressed('up')))
    }, [
      _createVNode(_component_icon_component, {
        class: "relative",
        name: "caretUp",
        color: _ctx.disabled || _ctx.disabledUp ? 'neutrals-300' : ''
      }, null, 8, ["color"])
    ], 2),
    _createVNode("div", {
      class: ["relative cursor-pointer no-select", _ctx.disabledDown ? '' : _ctx.classAtt],
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPressed('down')))
    }, [
      _createVNode(_component_icon_component, {
        class: "relative",
        name: "caretDown",
        color: _ctx.disabled || _ctx.disabledDown ? 'neutrals-300' : ''
      }, null, 8, ["color"])
    ], 2)
  ]))
})